import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import type {
    NotebookMessage,
    NotebookMessageCreate,
} from "@notebook/domain/models/notebook-message.model";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookMessageCreateUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookMessageRepository)
        private readonly notebookMessageRepository: NotebookMessageRepository,
    ) {}

    async execute(
        notebookId: string,
        notebookMessage: NotebookMessageCreate,
    ): Promise<Nullable<NotebookMessage>> {
        const createResult = await this.notebookMessageRepository.create(
            notebookId,
            notebookMessage,
        );

        return createResult.match(
            (notebookMessageCreated) => notebookMessageCreated,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
